
import {
  getCarConfiguer,
  getCarArea,
  getFuels
} from "@/api/userCenter/carManagement"

const cache = {
  state: {
    keys: 'cache',
    areas: [],
    models: [],
    fuels: []
  },
  mutations: {
    setAreas: (state, areas) => {
      state.areas = areas
    },
    setModels: (state, models) => {
      state.models = models
    },
    setFuels: (state, fuels) => {
      state.fuels = fuels
    }
  },
  actions: {
    loadAreas({ commit }) {
      getCarArea().then(({ data }) => {
        if (data.code === 0) {
          commit('setAreas', data.data)
        }
      })
    },
    loadModels({ commit }) {
      getCarConfiguer().then(({ data }) => {
        if (data.code === 0) {
          commit('setModels', data.data)
        }
      })
    },
    loadFuels({ commit }) {
      getFuels().then(({data}) => {
        if (data.code === 0) {
          commit('setFuels', data.data)
        }
      })
    }
  },
  getters: {
    cascaderModels: state => {
      return state.models.map(({brandId, brandName, brandCode, series = []}) => {
        return {
          id: brandId,
          name: brandName,
          code: brandCode,
          children: series.map(({seriesId, seriesName, seriesCode, models = []}) => {
            return {
              id: seriesId,
              name: seriesName,
              code: seriesCode,
              children: models.map(({modelId, modelName, modelCode}) => {
                return {
                  id: modelId,
                  name: modelName,
                  code: modelCode
                }
              })
            }
          })
        }
      })
    }
  }
}
export default cache
